import { AllocationBase } from "../../accounting/abstract/allocation-base.model";

export class CreditCardTransactionAllocation extends AllocationBase {

    static override CLASS_NAME: string = 'CreditCardTransactionAllocation';

}
